function Add(key: string, value: string | any, replaceIfExists = true) {
  if (typeof value !== 'string') value = JSON.stringify(value);

  if (Check(key) && !replaceIfExists) return;

  localStorage.setItem(key, value);
}

function Get(key: string): any | null {
  if (!Check(key)) return null;

  const value = localStorage.getItem(key);
  if (!value || value === 'null' || value === 'undefined') {
    return null;
  }
  return JSON.parse(value);
}

function Check(key: string) {
  return localStorage.getItem(key) !== null;
}

function Remove(key: string) {
  if (Check(key)) localStorage.removeItem(key);
}

function RemoveAll() {
  localStorage.clear();
}

export const LocalStorageService = {
  Add,
  Get,
  Check,
  Remove,
  RemoveAll,
};
